module.exports = __webpack_public_path__ + "img/cmbc.0156bea6.png";